import DoctorGrid from './DoctorGrid';

export default DoctorGrid;